import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { inject } from '@angular/core';
import { catchError, from, map, Observable, of } from 'rxjs';

export const AuthGuard: CanActivateFn = (route, state) => {
  const _storage = inject(StorageService);
  const router = inject(Router);
  return _storage.get('accessToken').then((token: any) => {
    if (token) {
      return true; 
    } else {
      router.navigate(['/login']);
      return false;
    }
  }).catch((error) => {
    router.navigate(['/login']);
    return false;
  });
};

export const NonAuthGuard: CanActivateFn = (route, state) => { 
  const _storage = inject(StorageService);
  const router = inject(Router);
  return _storage.get('accessToken').then((token) => {
    if (!!token) {
      router.navigate(['/home']);
      return false; 
    }
    return true;
  }).catch((error) => {
    return true;
  });
}
